module.exports = __webpack_public_path__ + "static/media/hughspa1.c9d827f7.jpg";